import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import { Toast, Dialog } from 'vant'
import store from '@/store'

var loadingInstance = null // 加载全局的loading
// axios 配置
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
const service = axios.create({
  baseURL: '/api',
  timeout: 60000 // 请求超时时间
})


// 请求时的拦截
service.interceptors.request.use( config => {
  
  // 加载中
  const noNeedToast = []
  if( noNeedToast.indexOf(config.url) != -1){
    loadingInstance = Toast.loading({
      duration: 0,
      forbidClick: true,
      message: '加载中...'
    })
  }

  
  // 设置token
  const token = store.state.token
  try {
    if (token) {
      config.headers.Authorization = token;
    }
  } catch (err) {
  }

  // 设置请求参数
  if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    config.data = qs.stringify(config.data)
  }


  return config;


},  error=> {  // 当请求异常时做一些处理

  return Promise.reject(error);
});




// 响应时拦截
service.interceptors.response.use(res => {
 
  // if (res.data.code == 400) {
  //   // 登录信息过期 跳转到登录页
  //   store.commit('setToken', '')
  //   Dialog.alert({
  //       message: '登录过期，请重新登录',
  //       confirmButtonColor: '#497CFF'
  //   }).then(() => {
  //       window.location.href = '/'
  //   });
    
  //   return false;  
  // }

  if(res.status == 500){
    Toast('网络错误')
  }
  
  return res;
},err => { // 当响应异常时做一些处理
  if(err){
    Toast('请求错误')
  }
  // loadingInstance && loadingInstance.clear();
  if (err && err.response) {
    switch (err.response.code) {
      case 400:
        err.message = '请求错误'
        break

      case 401:
        err.message = '未授权，请登录'
        break

      case 403:
        err.message = '拒绝访问'
        break

      case 404:
        err.message = `请求地址出错: ${err.response.config.url}`
        break

      case 408:
        err.message = '请求超时'
        break

      case 500:
        err.message = '服务器内部错误'
        break

      case 501:
        err.message = '服务未实现'
        break

      case 502:
        err.message = '网关错误'
        break

      case 503:
        err.message = '服务不可用'
        break

      case 504:
        err.message = '网关超时'
        break

      case 505:
        err.message = 'HTTP版本不受支持'
        break

      default:
    }
  }
  return Promise.reject(err);
});

// 封装post
export function post(url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, params) // 将参数序列化
    .then(res => {
      resolve(res.data);
    }, err => {
      reject(err);
    })
    .catch((error) => {
      reject(error)
    })
  })
}

// 封装get方法
export function get(url){
  return new Promise((resolve,reject) => {
    service.get(url)
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}